import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";

import { PlanViewerLayerDetails } from "../planviewer";
import { IPvLayerMap, OlLayerTypeImplT, PvLayer } from "./pvlayer";
import { PvLayerWFS } from "./wfs";

export const IsLayerDKK = (
  layer: PlanViewerLayerDetails
): layer is PvLayerDKK => {
  return layer.type === "dkk";
};
export class PvLayerDKK extends PvLayer implements IPvLayerMap {
  getOlLayer(_options: Record<string, unknown>): OlLayerTypeImplT {
    const wfs_url =
      "https://geodata.nationaalgeoregister.nl/kadastralekaart/wfs/v4_0";
    const wfs_layer_name = "kadastralekaartv4:perceel";
    const style = new Style({ stroke: new Stroke({ color: "red" }) });
    const ol = PvLayerWFS.wrap(this, wfs_url, wfs_layer_name, {
      style,
      minZoom: 16,
    });
    ol.setVisible(this.show_layer || this.consultable);
    return ol;
  }
}
